import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import _ from 'lodash';

import { Idea } from '../../../models/Sessions/Idea/Idea';
import { getTagsForIdeas } from '../FilterHelper';

@Component({
  selector: 'app-word-cloud-filter',
  templateUrl: './word-cloud-filter.component.html',
  styleUrls: ['./word-cloud-filter.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class WordCloudFilterComponent implements OnInit {
  private selectedTags: object = {};
  dropdownList = [];
  selectedItems: object[] = [];

  initialized = false;

  @Output() updatedFilter = new EventEmitter();
  @Input() ideas: Idea[] = [];
  private _filteredIdeas: Idea[];
  private allTags: any[] = [];
  public filteredTags: any[] = [];

  @Input() set filteredIdeas(ideas: Idea[]) {
    if (!ideas) {
      return;
    }

    this.setFilteredIdeas(ideas);
    // tags in allIdeas
    this.allTags = _.uniq(getTagsForIdeas(this.ideas));
    this.filteredTags = this.getTags(true);
    this.disabledWords = this.updateDisabledWords();
    this.initializeDropdownList();
  }

  disabledWords: any[] = [];
  tags: string[];
  highlightedWords: string[];
  selectedTagsList: any[] = [];

  get placeHolderString() {
    if (this.allTags.length > this.filteredTags.length) {
      return (
        'Select or Search Tags (' +
        this.filteredTags.length +
        ' our of ' +
        this.allTags.length +
        ')'
      );
    }
    return 'Select or Search Tags (' + this.allTags.length + ')';
  }

  updateDisabledWords() {
    return _.difference(this.allTags, this.filteredTags);
  }

  initializeDropdownList() {
    const allGroupedTags = this.getGroupedTags(false);
    const filteredGroupedTags = this.getGroupedTags(true);

    this.dropdownList = _.keys(allGroupedTags)
      .filter(tag => tag in filteredGroupedTags || this.isSelected(tag))
      .map(tag => {
        return { id: tag, name: tag };
      });
  }

  setFilteredIdeas(ideas) {
    this._filteredIdeas = ideas;
  }

  getFilteredIdeas() {
    return this._filteredIdeas || [];
  }

  ngOnInit() {
    this.tags = this.getTags();
    const groupedTags = this.getGroupedTags();
    this.initializeDropdownList();

    _.keys(groupedTags).forEach(tag => {
      this.selectedTags[tag] = false;
    });
  }

  getTags(filteredOnly = false) {
    if (filteredOnly) {
      return _.flatten(
        this.getFilteredIdeas().map(idea => (idea['tags'] ? idea['tags'] : [])),
      );
    } else {
      return _.flatten(
        this.ideas.map(idea => (idea['tags'] ? idea['tags'] : [])),
      );
    }
  }

  getGroupedTags(filteredOnly = false) {
    const allTags = this.getTags(filteredOnly);
    const groupedTags = _.groupBy(allTags, _.identity);

    return groupedTags;
  }

  updateSelectedItems() {
    this.highlightedWords = _.keys(this.selectedTags).filter(
      tag => this.selectedTags[tag],
    );

    this.updatedFilter.emit(this.highlightedWords);
  }

  isSelected(tag) {
    return this.selectedTags[tag];
  }

  toggleTag(tag) {
    this.selectedTags[tag] = !this.selectedTags[tag];
    this.updateSelectedItems();

    this.selectedTagsList = [];
    for (const _tag of _.keys(this.selectedTags)) {
      if (this.selectedTags[_tag]) {
        this.selectedTagsList.push(_tag);
      }
    }
  }

  onSelectionChanged(selectedTags: any) {
    for (const tag of _.keys(this.selectedTags)) {
      this.selectedTags[tag] = false;
    }
    for (const tag of selectedTags) {
      this.selectedTags[tag] = true;
    }

    this.updateSelectedItems();
  }
}
